<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path d="m21 3-18 7.53v.98l6.84 2.65 2.64 6.84h.98z" />
  </svg>
</template>
